import { useTranslation } from "react-i18next";
import { Check, X } from "lucide-react";

// شريط سفلي مثبت — زر أخضر (تأكيد الاستلام) + زر أحمر (رفض الاستلام مع السبب).
export const MyBillSignActions = ({ busy, canConfirm, onConfirm, onReject }) => {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 p-4 backdrop-blur"
         style={{ paddingBottom: "max(env(safe-area-inset-bottom), 1rem)" }}
         data-testid="my-sign-actions">
      <div className="mx-auto flex max-w-2xl gap-3">
        <button data-testid="my-reject" onClick={onReject} disabled={busy}
                className="flex flex-1 items-center justify-center gap-2 rounded-2xl bg-rose-600 px-4 py-3 text-sm font-black text-white shadow-md hover:bg-rose-700 disabled:opacity-50">
          <X className="h-4 w-4" /> {t("acct.bills.mysign.reject")}
        </button>
        <button data-testid="my-confirm" onClick={onConfirm} disabled={busy || !canConfirm}
                className="flex flex-1 items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 py-3 text-sm font-black text-white shadow-md hover:bg-emerald-700 disabled:opacity-50">
          <Check className="h-4 w-4" /> {t("acct.bills.mysign.confirm")}
        </button>
      </div>
    </div>
  );
};
